import { CheckCircle, XCircle } from "lucide-react";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";

const ResultDialog = ({ result, type, onClose }) => (
  <Dialog open={!!result} onOpenChange={(open) => { if (!open) onClose(); }}>
    <DialogContent data-testid={`${type.toLowerCase()}-result-dialog`}>
      <DialogHeader>
        <DialogTitle>{type} Results</DialogTitle>
      </DialogHeader>
      <div className="space-y-4 py-2">
        <div className="grid grid-cols-2 gap-4">
          <div className="flex items-center gap-2 p-3 bg-green-50 rounded-lg">
            <CheckCircle className="w-5 h-5 text-green-600" />
            <div>
              <p className="text-sm font-medium text-green-700">Sent</p>
              <p className="text-2xl font-bold text-green-800" data-testid="result-sent-count">{result.sent_count}</p>
            </div>
          </div>
          {result.failed_count > 0 && (
            <div className="flex items-center gap-2 p-3 bg-red-50 rounded-lg">
              <XCircle className="w-5 h-5 text-red-600" />
              <div>
                <p className="text-sm font-medium text-red-700">Failed</p>
                <p className="text-2xl font-bold text-red-800" data-testid="result-failed-count">{result.failed_count}</p>
              </div>
            </div>
          )}
        </div>
        {result.failed?.length > 0 && (
          <div className="space-y-1">
            <p className="text-sm font-medium text-muted-foreground">Failed recipients:</p>
            {result.failed.map((f, i) => (
              <div key={i} className="flex justify-between text-sm p-2 bg-red-50 rounded">
                <span>{f.name}</span>
                <span className="text-red-600 text-xs">{f.reason}</span>
              </div>
            ))}
          </div>
        )}
        <Button onClick={onClose} className="w-full" data-testid="result-done-btn">Done</Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default ResultDialog;
